import e from "react";
var n,
  r = {
    exports: {}
  },
  t = {
    exports: {}
  },
  o = {};
var a,
  i,
  c,
  u,
  s,
  l,
  f,
  p,
  m,
  y,
  d,
  _,
  b,
  v,
  g = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function h() {
  return i || (i = 1, "production" === process.env.NODE_ENV ? t.exports = function () {
    if (n) return o;
    n = 1;
    var e = "function" == typeof Symbol && Symbol.for,
      r = e ? Symbol.for("react.element") : 60103,
      t = e ? Symbol.for("react.portal") : 60106,
      a = e ? Symbol.for("react.fragment") : 60107,
      i = e ? Symbol.for("react.strict_mode") : 60108,
      c = e ? Symbol.for("react.profiler") : 60114,
      u = e ? Symbol.for("react.provider") : 60109,
      s = e ? Symbol.for("react.context") : 60110,
      l = e ? Symbol.for("react.async_mode") : 60111,
      f = e ? Symbol.for("react.concurrent_mode") : 60111,
      p = e ? Symbol.for("react.forward_ref") : 60112,
      m = e ? Symbol.for("react.suspense") : 60113,
      y = e ? Symbol.for("react.suspense_list") : 60120,
      d = e ? Symbol.for("react.memo") : 60115,
      _ = e ? Symbol.for("react.lazy") : 60116,
      b = e ? Symbol.for("react.block") : 60121,
      v = e ? Symbol.for("react.fundamental") : 60117,
      g = e ? Symbol.for("react.responder") : 60118,
      h = e ? Symbol.for("react.scope") : 60119;
    function x(e) {
      if ("object" == typeof e && null !== e) {
        var n = e.$$typeof;
        switch (n) {
          case r:
            switch (e = e.type) {
              case l:
              case f:
              case a:
              case c:
              case i:
              case m:
                return e;
              default:
                switch (e = e && e.$$typeof) {
                  case s:
                  case p:
                  case _:
                  case d:
                  case u:
                    return e;
                  default:
                    return n;
                }
            }
          case t:
            return n;
        }
      }
    }
    function T(e) {
      return x(e) === f;
    }
    return o.AsyncMode = l, o.ConcurrentMode = f, o.ContextConsumer = s, o.ContextProvider = u, o.Element = r, o.ForwardRef = p, o.Fragment = a, o.Lazy = _, o.Memo = d, o.Portal = t, o.Profiler = c, o.StrictMode = i, o.Suspense = m, o.isAsyncMode = function (e) {
      return T(e) || x(e) === l;
    }, o.isConcurrentMode = T, o.isContextConsumer = function (e) {
      return x(e) === s;
    }, o.isContextProvider = function (e) {
      return x(e) === u;
    }, o.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === r;
    }, o.isForwardRef = function (e) {
      return x(e) === p;
    }, o.isFragment = function (e) {
      return x(e) === a;
    }, o.isLazy = function (e) {
      return x(e) === _;
    }, o.isMemo = function (e) {
      return x(e) === d;
    }, o.isPortal = function (e) {
      return x(e) === t;
    }, o.isProfiler = function (e) {
      return x(e) === c;
    }, o.isStrictMode = function (e) {
      return x(e) === i;
    }, o.isSuspense = function (e) {
      return x(e) === m;
    }, o.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === a || e === f || e === c || e === i || e === m || e === y || "object" == typeof e && null !== e && (e.$$typeof === _ || e.$$typeof === d || e.$$typeof === u || e.$$typeof === s || e.$$typeof === p || e.$$typeof === v || e.$$typeof === g || e.$$typeof === h || e.$$typeof === b);
    }, o.typeOf = x, o;
  }() : t.exports = (a || (a = 1, "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
      n = e ? Symbol.for("react.element") : 60103,
      r = e ? Symbol.for("react.portal") : 60106,
      t = e ? Symbol.for("react.fragment") : 60107,
      o = e ? Symbol.for("react.strict_mode") : 60108,
      a = e ? Symbol.for("react.profiler") : 60114,
      i = e ? Symbol.for("react.provider") : 60109,
      c = e ? Symbol.for("react.context") : 60110,
      u = e ? Symbol.for("react.async_mode") : 60111,
      s = e ? Symbol.for("react.concurrent_mode") : 60111,
      l = e ? Symbol.for("react.forward_ref") : 60112,
      f = e ? Symbol.for("react.suspense") : 60113,
      p = e ? Symbol.for("react.suspense_list") : 60120,
      m = e ? Symbol.for("react.memo") : 60115,
      y = e ? Symbol.for("react.lazy") : 60116,
      d = e ? Symbol.for("react.block") : 60121,
      _ = e ? Symbol.for("react.fundamental") : 60117,
      b = e ? Symbol.for("react.responder") : 60118,
      v = e ? Symbol.for("react.scope") : 60119;
    function h(e) {
      if ("object" == typeof e && null !== e) {
        var p = e.$$typeof;
        switch (p) {
          case n:
            var d = e.type;
            switch (d) {
              case u:
              case s:
              case t:
              case a:
              case o:
              case f:
                return d;
              default:
                var _ = d && d.$$typeof;
                switch (_) {
                  case c:
                  case l:
                  case y:
                  case m:
                  case i:
                    return _;
                  default:
                    return p;
                }
            }
          case r:
            return p;
        }
      }
    }
    var x = u,
      T = s,
      S = c,
      w = i,
      E = n,
      O = l,
      N = t,
      $ = y,
      j = m,
      P = r,
      I = a,
      k = o,
      C = f,
      M = !1;
    function D(e) {
      return h(e) === s;
    }
    g.AsyncMode = x, g.ConcurrentMode = T, g.ContextConsumer = S, g.ContextProvider = w, g.Element = E, g.ForwardRef = O, g.Fragment = N, g.Lazy = $, g.Memo = j, g.Portal = P, g.Profiler = I, g.StrictMode = k, g.Suspense = C, g.isAsyncMode = function (e) {
      return M || (M = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), D(e) || h(e) === u;
    }, g.isConcurrentMode = D, g.isContextConsumer = function (e) {
      return h(e) === c;
    }, g.isContextProvider = function (e) {
      return h(e) === i;
    }, g.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, g.isForwardRef = function (e) {
      return h(e) === l;
    }, g.isFragment = function (e) {
      return h(e) === t;
    }, g.isLazy = function (e) {
      return h(e) === y;
    }, g.isMemo = function (e) {
      return h(e) === m;
    }, g.isPortal = function (e) {
      return h(e) === r;
    }, g.isProfiler = function (e) {
      return h(e) === a;
    }, g.isStrictMode = function (e) {
      return h(e) === o;
    }, g.isSuspense = function (e) {
      return h(e) === f;
    }, g.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === t || e === s || e === a || e === o || e === f || e === p || "object" == typeof e && null !== e && (e.$$typeof === y || e.$$typeof === m || e.$$typeof === i || e.$$typeof === c || e.$$typeof === l || e.$$typeof === _ || e.$$typeof === b || e.$$typeof === v || e.$$typeof === d);
    }, g.typeOf = h;
  }()), g)), t.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
function x() {
  if (u) return c;
  u = 1;
  var e = Object.getOwnPropertySymbols,
    n = Object.prototype.hasOwnProperty,
    r = Object.prototype.propertyIsEnumerable;
  return c = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var n = {}, r = 0; r < 10; r++) n["_" + String.fromCharCode(r)] = r;
      if ("0123456789" !== Object.getOwnPropertyNames(n).map(function (e) {
        return n[e];
      }).join("")) return !1;
      var t = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        t[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, t)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (t, o) {
    for (var a, i, c = function (e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(t), u = 1; u < arguments.length; u++) {
      for (var s in a = Object(arguments[u])) n.call(a, s) && (c[s] = a[s]);
      if (e) {
        i = e(a);
        for (var l = 0; l < i.length; l++) r.call(a, i[l]) && (c[i[l]] = a[i[l]]);
      }
    }
    return c;
  }, c;
}
function T() {
  if (l) return s;
  l = 1;
  return s = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}
function S() {
  return p ? f : (p = 1, f = Function.call.bind(Object.prototype.hasOwnProperty));
}
if ("production" !== process.env.NODE_ENV) {
  var w = h();
  r.exports = function () {
    if (_) return d;
    _ = 1;
    var e = h(),
      n = x(),
      r = T(),
      t = S(),
      o = function () {
        if (y) return m;
        y = 1;
        var e = function e() {};
        if ("production" !== process.env.NODE_ENV) {
          var n = T(),
            r = {},
            t = S();
          e = function e(_e) {
            var n = "Warning: " + _e;
            "undefined" != typeof console && console.error(n);
            try {
              throw new Error(n);
            } catch (e) {}
          };
        }
        function o(o, a, i, c, u) {
          if ("production" !== process.env.NODE_ENV) for (var s in o) if (t(o, s)) {
            var l;
            try {
              if ("function" != typeof o[s]) {
                var f = Error((c || "React class") + ": " + i + " type `" + s + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[s] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw f.name = "Invariant Violation", f;
              }
              l = o[s](a, s, c, i, null, n);
            } catch (e) {
              l = e;
            }
            if (!l || l instanceof Error || e((c || "React class") + ": type specification of " + i + " `" + s + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof l + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), l instanceof Error && !(l.message in r)) {
              r[l.message] = !0;
              var p = u ? u() : "";
              e("Failed " + i + " type: " + l.message + (null != p ? p : ""));
            }
          }
        }
        return o.resetWarningCache = function () {
          "production" !== process.env.NODE_ENV && (r = {});
        }, m = o;
      }(),
      a = function a() {};
    function i() {
      return null;
    }
    return "production" !== process.env.NODE_ENV && (a = function a(e) {
      var n = "Warning: " + e;
      "undefined" != typeof console && console.error(n);
      try {
        throw new Error(n);
      } catch (e) {}
    }), d = function d(c, u) {
      var s = "function" == typeof Symbol && Symbol.iterator,
        l = "@@iterator",
        f = "<<anonymous>>",
        p = {
          array: _("array"),
          bigint: _("bigint"),
          bool: _("boolean"),
          func: _("function"),
          number: _("number"),
          object: _("object"),
          string: _("string"),
          symbol: _("symbol"),
          any: d(i),
          arrayOf: function arrayOf(e) {
            return d(function (n, t, o, a, i) {
              if ("function" != typeof e) return new y("Property `" + i + "` of component `" + o + "` has invalid PropType notation inside arrayOf.");
              var c = n[t];
              if (!Array.isArray(c)) return new y("Invalid " + a + " `" + i + "` of type `" + g(c) + "` supplied to `" + o + "`, expected an array.");
              for (var u = 0; u < c.length; u++) {
                var s = e(c, u, o, a, i + "[" + u + "]", r);
                if (s instanceof Error) return s;
              }
              return null;
            });
          },
          element: d(function (e, n, r, t, o) {
            var a = e[n];
            return c(a) ? null : new y("Invalid " + t + " `" + o + "` of type `" + g(a) + "` supplied to `" + r + "`, expected a single ReactElement.");
          }),
          elementType: d(function (n, r, t, o, a) {
            var i = n[r];
            return e.isValidElementType(i) ? null : new y("Invalid " + o + " `" + a + "` of type `" + g(i) + "` supplied to `" + t + "`, expected a single ReactElement type.");
          }),
          instanceOf: function instanceOf(e) {
            return d(function (n, r, t, o, a) {
              if (!(n[r] instanceof e)) {
                var i = e.name || f;
                return new y("Invalid " + o + " `" + a + "` of type `" + ((c = n[r]).constructor && c.constructor.name ? c.constructor.name : f) + "` supplied to `" + t + "`, expected instance of `" + i + "`.");
              }
              var c;
              return null;
            });
          },
          node: d(function (e, n, r, t, o) {
            return v(e[n]) ? null : new y("Invalid " + t + " `" + o + "` supplied to `" + r + "`, expected a ReactNode.");
          }),
          objectOf: function objectOf(e) {
            return d(function (n, o, a, i, c) {
              if ("function" != typeof e) return new y("Property `" + c + "` of component `" + a + "` has invalid PropType notation inside objectOf.");
              var u = n[o],
                s = g(u);
              if ("object" !== s) return new y("Invalid " + i + " `" + c + "` of type `" + s + "` supplied to `" + a + "`, expected an object.");
              for (var l in u) if (t(u, l)) {
                var f = e(u, l, a, i, c + "." + l, r);
                if (f instanceof Error) return f;
              }
              return null;
            });
          },
          oneOf: function oneOf(e) {
            return Array.isArray(e) ? d(function (n, r, t, o, a) {
              for (var i = n[r], c = 0; c < e.length; c++) if (m(i, e[c])) return null;
              var u = JSON.stringify(e, function (e, n) {
                return "symbol" === h(n) ? String(n) : n;
              });
              return new y("Invalid " + o + " `" + a + "` of value `" + String(i) + "` supplied to `" + t + "`, expected one of " + u + ".");
            }) : ("production" !== process.env.NODE_ENV && a(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), i);
          },
          oneOfType: function oneOfType(e) {
            if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;
            for (var n = 0; n < e.length; n++) {
              var o = e[n];
              if ("function" != typeof o) return a("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + x(o) + " at index " + n + "."), i;
            }
            return d(function (n, o, a, i, c) {
              for (var u = [], s = 0; s < e.length; s++) {
                var l = (0, e[s])(n, o, a, i, c, r);
                if (null == l) return null;
                l.data && t(l.data, "expectedType") && u.push(l.data.expectedType);
              }
              return new y("Invalid " + i + " `" + c + "` supplied to `" + a + "`" + (u.length > 0 ? ", expected one of type [" + u.join(", ") + "]" : "") + ".");
            });
          },
          shape: function shape(e) {
            return d(function (n, t, o, a, i) {
              var c = n[t],
                u = g(c);
              if ("object" !== u) return new y("Invalid " + a + " `" + i + "` of type `" + u + "` supplied to `" + o + "`, expected `object`.");
              for (var s in e) {
                var l = e[s];
                if ("function" != typeof l) return b(o, a, i, s, h(l));
                var f = l(c, s, o, a, i + "." + s, r);
                if (f) return f;
              }
              return null;
            });
          },
          exact: function exact(e) {
            return d(function (o, a, i, c, u) {
              var s = o[a],
                l = g(s);
              if ("object" !== l) return new y("Invalid " + c + " `" + u + "` of type `" + l + "` supplied to `" + i + "`, expected `object`.");
              var f = n({}, o[a], e);
              for (var p in f) {
                var m = e[p];
                if (t(e, p) && "function" != typeof m) return b(i, c, u, p, h(m));
                if (!m) return new y("Invalid " + c + " `" + u + "` key `" + p + "` supplied to `" + i + "`.\nBad object: " + JSON.stringify(o[a], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
                var d = m(s, p, i, c, u + "." + p, r);
                if (d) return d;
              }
              return null;
            });
          }
        };
      function m(e, n) {
        return e === n ? 0 !== e || 1 / e == 1 / n : e != e && n != n;
      }
      function y(e, n) {
        this.message = e, this.data = n && "object" == typeof n ? n : {}, this.stack = "";
      }
      function d(e) {
        if ("production" !== process.env.NODE_ENV) var n = {},
          t = 0;
        function o(o, i, c, s, l, p, m) {
          if (s = s || f, p = p || c, m !== r) {
            if (u) {
              var d = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw d.name = "Invariant Violation", d;
            }
            if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
              var _ = s + ":" + c;
              !n[_] && t < 3 && (a("You are manually calling a React.PropTypes validation function for the `" + p + "` prop on `" + s + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[_] = !0, t++);
            }
          }
          return null == i[c] ? o ? null === i[c] ? new y("The " + l + " `" + p + "` is marked as required in `" + s + "`, but its value is `null`.") : new y("The " + l + " `" + p + "` is marked as required in `" + s + "`, but its value is `undefined`.") : null : e(i, c, s, l, p);
        }
        var i = o.bind(null, !1);
        return i.isRequired = o.bind(null, !0), i;
      }
      function _(e) {
        return d(function (n, r, t, o, a, i) {
          var c = n[r];
          return g(c) !== e ? new y("Invalid " + o + " `" + a + "` of type `" + h(c) + "` supplied to `" + t + "`, expected `" + e + "`.", {
            expectedType: e
          }) : null;
        });
      }
      function b(e, n, r, t, o) {
        return new y((e || "React class") + ": " + n + " type `" + r + "." + t + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + o + "`.");
      }
      function v(e) {
        switch (typeof e) {
          case "number":
          case "string":
          case "undefined":
            return !0;
          case "boolean":
            return !e;
          case "object":
            if (Array.isArray(e)) return e.every(v);
            if (null === e || c(e)) return !0;
            var n = function (e) {
              var n = e && (s && e[s] || e[l]);
              if ("function" == typeof n) return n;
            }(e);
            if (!n) return !1;
            var r,
              t = n.call(e);
            if (n !== e.entries) {
              for (; !(r = t.next()).done;) if (!v(r.value)) return !1;
            } else for (; !(r = t.next()).done;) {
              var o = r.value;
              if (o && !v(o[1])) return !1;
            }
            return !0;
          default:
            return !1;
        }
      }
      function g(e) {
        var n = typeof e;
        return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, n) {
          return "symbol" === e || !!n && ("Symbol" === n["@@toStringTag"] || "function" == typeof Symbol && n instanceof Symbol);
        }(n, e) ? "symbol" : n;
      }
      function h(e) {
        if (null == e) return "" + e;
        var n = g(e);
        if ("object" === n) {
          if (e instanceof Date) return "date";
          if (e instanceof RegExp) return "regexp";
        }
        return n;
      }
      function x(e) {
        var n = h(e);
        switch (n) {
          case "array":
          case "object":
            return "an " + n;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + n;
          default:
            return n;
        }
      }
      return y.prototype = Error.prototype, p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
    }, d;
  }()(w.isElement, !0);
} else r.exports = function () {
  if (v) return b;
  v = 1;
  var e = T();
  function n() {}
  function r() {}
  return r.resetWarningCache = n, b = function b() {
    function t(n, r, t, o, a, i) {
      if (i !== e) {
        var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw c.name = "Invariant Violation", c;
      }
    }
    function o() {
      return t;
    }
    t.isRequired = t;
    var a = {
      array: t,
      bigint: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: o,
      element: t,
      elementType: t,
      instanceOf: o,
      node: t,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: r,
      resetWarningCache: n
    };
    return a.PropTypes = a, a;
  };
}()();
var E = r.exports;
var O = "Teammate-module_player_box__I-U-y",
  N = "Teammate-module_player_wrapper__sE-8o",
  $ = "Teammate-module_team_logo__V5isb",
  j = "Teammate-module_player_number__SrmNS",
  P = "Teammate-module_player_position__H7yMc",
  I = "Teammate-module_player_image__nkkTS",
  k = "Teammate-module_player_name__DQ79N";
function C() {
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
  return n.filter(Boolean).join(" ");
}
!function (e, n) {
  void 0 === n && (n = {});
  var r = n.insertAt;
  if (e && "undefined" != typeof document) {
    var t = document.head || document.getElementsByTagName("head")[0],
      o = document.createElement("style");
    o.type = "text/css", "top" === r && t.firstChild ? t.insertBefore(o, t.firstChild) : t.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
  }
}('.Teammate-module_player_box__I-U-y {\n  width: 100px;\n  border: 1px;\n  position: relative;\n  color: #fff;\n  font-family: "protipo-narrow";\n}\n.Teammate-module_player_box__I-U-y .Teammate-module_player_wrapper__sE-8o {\n  height: 264px;\n  width: 100%;\n  background-color: #868e96;\n  border-radius: 7px 7px 55px 7px;\n  overflow: hidden;\n  position: relative;\n  margin-bottom: 10px;\n}\n.Teammate-module_player_box__I-U-y .Teammate-module_player_wrapper__sE-8o .Teammate-module_team_logo__V5isb {\n  position: relative;\n  border-radius: 50%;\n  height: 48px;\n  width: 48px;\n  top: 18px;\n  margin: 0 auto;\n  margin-bottom: 30px;\n  background-color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.Teammate-module_player_box__I-U-y .Teammate-module_player_wrapper__sE-8o .Teammate-module_team_logo__V5isb > img {\n  width: 30px;\n  height: 30px;\n}\n.Teammate-module_player_box__I-U-y .Teammate-module_player_wrapper__sE-8o .Teammate-module_player_number__SrmNS {\n  position: relative;\n  font-size: 40px;\n  font-style: italic;\n  font-weight: 900;\n  text-align: center;\n  margin: 0 0 0px 0;\n}\n.Teammate-module_player_box__I-U-y .Teammate-module_player_wrapper__sE-8o .Teammate-module_player_position__H7yMc {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 16px;\n  text-align: center;\n}\n.Teammate-module_player_box__I-U-y .Teammate-module_player_wrapper__sE-8o .Teammate-module_player_image__nkkTS {\n  object-fit: cover;\n  position: absolute;\n  bottom: 0;\n}\n.Teammate-module_player_box__I-U-y .Teammate-module_player_name__DQ79N {\n  width: 96px;\n  text-align: center;\n  font-family: "protipo-narrow";\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 19px;\n  text-transform: uppercase;\n}\n.Teammate-module_player_box__I-U-y .Teammate-module_player_name__DQ79N > span {\n  font-weight: 700;\n}\n\n@media (prefers-color-scheme: dark) {\n  .Teammate-module_player_name__DQ79N {\n    color: #fff;\n  }\n}\n.darkMode .Teammate-module_player_name__DQ79N {\n  color: #fff;\n}\n\n@media (prefers-color-scheme: light) {\n  .Teammate-module_player_name__DQ79N {\n    color: #002b49;\n  }\n  .Teammate-module_player_name__DQ79N > span {\n    color: #002b49;\n  }\n}\n.lightMode .Teammate-module_player_name__DQ79N {\n  color: #002b49;\n}\n.lightMode .Teammate-module_player_name__DQ79N > span {\n  color: #002b49;\n}');
var M = function M(n) {
  var r = n.teamLogo,
    t = n.number,
    o = n.position,
    a = n.image,
    i = n.firstName,
    c = n.lastName,
    u = n.bgDesign,
    s = n.forceColorScheme;
  return e.createElement("div", {
    className: C(O, s)
  }, e.createElement("div", {
    style: {
      backgroundImage: "url(".concat(u, ")")
    },
    className: N
  }, e.createElement("div", {
    className: $
  }, e.createElement("img", {
    src: r
  })), e.createElement("div", {
    className: j
  }, t), e.createElement("div", {
    className: P
  }, o), e.createElement("img", {
    className: I,
    src: a
  })), e.createElement("div", {
    className: k
  }, i, " ", e.createElement("span", null, c)));
};
M.propTypes = {
  forceColorScheme: E.PropTypes.oneOf(["darkMode", "lightMode", "system"]).isRequired,
  teamLogo: E.PropTypes.string,
  number: E.PropTypes.string,
  position: E.PropTypes.string,
  image: E.PropTypes.string,
  firstName: E.PropTypes.string,
  lastName: E.PropTypes.string,
  bgDesign: E.PropTypes.string
}, M.defaultProps = {
  forceColorScheme: "lightMode"
};
export { M as Teammates, M as default };